var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293692",
    "data-name": "Group 293692",
    transform: "translate(-270 -943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    transform: "translate(270 943)",
    fill: "#ff13dc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "S_YouTube_18_N",
    d: "M17.771,4.921a3.869,3.869,0,0,0-.712-1.776,2.561,2.561,0,0,0-1.793-.758C12.761,2.2,9,2.2,9,2.2H9s-3.757,0-6.262.181a2.562,2.562,0,0,0-1.793.758A3.867,3.867,0,0,0,.229,4.921a27.075,27.075,0,0,0-.179,2.9V9.178a27.088,27.088,0,0,0,.179,2.9A3.867,3.867,0,0,0,.941,13.85a3.033,3.033,0,0,0,1.974.765C4.347,14.752,9,14.8,9,14.8s3.761-.006,6.266-.187a2.558,2.558,0,0,0,1.793-.758,3.869,3.869,0,0,0,.712-1.777,27.163,27.163,0,0,0,.179-2.9V7.818A27.135,27.135,0,0,0,17.771,4.921ZM7,11.08v-5.3l5.291,2.66Z",
    transform: "translate(269.95 943.795)",
    fill: "#222",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.031658a223f006d40179cadf04ef1f9e.svg";
export { ForwardRef as ReactComponent };